export default __webpack_public_path__ + "static/media/ANUENCIA_MUNICIPAL_PARA_PARTICULARES_2024.1aaf9c01.pdf";